// extracted by mini-css-extract-plugin
module.exports = {"underConstruction":"totalizer_underConstruction__vaZIE"};